export * from './shopping-service';
console.warn('search-service is deprecated. Please use shopping-service instead.');
